import { Component, OnInit } from '@angular/core';
import { ConfigurationService } from '../../../services/configuration/configuration.service';
import { AdressePhysiqueCredit } from '../../../api/model/adresse-physique-credit.model';
import { FormGroup } from '@angular/forms';
import { FormulaireFiserv } from '../../../models/formulaire/formulaire-fiserv.model';
import { NavigationService } from '../../../services/navigation/navigation.service';
import { FormulaireFiservService } from '../../../services/formulaire-fiserv/formulaire-fiserv.service';
import { ReponseCoordonneesCreditService } from '../../../services/reponse-coordonnees-credit/reponse-coordonnees-credit.service';
import { LangueService } from '../../../services/langue/langue.service';
import { GlobalStoreService } from '../../../services/global-store/global-store.service';
import { ChangementCoordonneeCreditFiservAccesDService } from '../../../services/changement-coordonnee-credit-fiserv-accesd/changement-coordonnee-credit-fiserv-acces-d.service';
import { ConvertisseurDeModelService } from '../../../services/convertisseur-de-model/convertisseur-de-model.service';
import { CybermetrieEnum } from '../../../models/cybermetrie/cybermetrie.enum';
import { CybermetrieCoordonneesService } from '../../../services/cybermetrie/cybermetrie.service';
import { HttpErrorResponse } from '@angular/common/http';
import { GestionErreurService } from 'src/app/services/gestion-erreur/gestion-erreur.service';
import { GestionTitreService } from '../../../services/navigation/gestion-titre.service';

@Component({
  selector: 'app-validation-fiserv',
  templateUrl: './validation-fiserv.component.html',
  standalone: false,
})
export class ValidationFiservComponent implements OnInit {
  formGroupLocal: FormGroup<FormulaireFiserv>;
  isAppMobile: boolean;
  titre: string;
  titreAdressePostale: string;
  titreTelephone: string;
  titreAdresseCourriel: string;
  particuliersCreditPlusQueUn: boolean = false;
  adressePostale: AdressePhysiqueCredit;
  codeErreur: string = '';

  constructor(
    private readonly configService: ConfigurationService,
    private readonly navigationService: NavigationService,
    private readonly formulaireFiservService: FormulaireFiservService,
    private readonly globalStoreService: GlobalStoreService,
    private readonly reponseCoordonneesCreditService: ReponseCoordonneesCreditService,
    private readonly langueService: LangueService,
    private readonly coordonneesCreditService: ChangementCoordonneeCreditFiservAccesDService,
    private readonly convertisseurDeModelService: ConvertisseurDeModelService,
    private readonly cybermetrieService: CybermetrieCoordonneesService,
    private readonly gestionErreurService: GestionErreurService,
    private readonly gestionTitreService: GestionTitreService
  ) {}

  ngOnInit(): void {
    this.formGroupLocal = this.formulaireFiservService.getForm();
    this.isAppMobile = this.configService.getValueOrDefault(configuration.ConfigMeta.OEL_IS_APP, 'false') === 'true';
    this.particuliersCreditPlusQueUn = this.reponseCoordonneesCreditService.estParticuliersCreditPlusQueUn();
    this.adressePostale = this.formGroupLocal.controls.utiliserMemeAdresse.value
      ? this.reponseCoordonneesCreditService.getAdresseCourante()
      : this.getAdresseSaisie();
    this.cybermetrieService.envoyerEvenementPersonnalise(
      CybermetrieEnum.CATEGORIE_TRANSACTION,
      CybermetrieEnum.ACTION_ETAPE,
      CybermetrieEnum.LABEL_INFOS_TOTAL
    );
    this.initialiserTitres();
  }

  annulerModification(): void {
    this.globalStoreService.saveEtatAfficherModaleAnnuler(true);
  }

  naviguerVersModifier(): void {
    this.navigationService.naviguerVersModificationCredit();
  }

  soumettreFormulaire(): void {
    this.coordonneesCreditService
      .patchCoordooneesCredit$(this.convertisseurDeModelService.construireRequeteModifierCoordonnees())
      .subscribe({
        next: () => {
          this.navigationService.naviguerVersPageConfirmationCredit();
        },
        error: (err: HttpErrorResponse) => {
          this.codeErreur = this.gestionErreurService.getCodeErreur(err);
          this.navigationService.naviguerVersPageErreurCredit(
            err.status.toString(),
            this.codeErreur,
            this.gestionErreurService.getMessageErreur(err)
          );
        },
      });
  }

  private initialiserTitres(): void {
    this.titre = this.particuliersCreditPlusQueUn ? 'caad.titreMulticarte' : 'caad.titre';
    this.titreAdressePostale = this.formGroupLocal.controls.utiliserMemeAdresse.value
      ? 'caad.modifier-fiserv.validation.adressePostale'
      : 'caad.modifier-fiserv.validation.nouvelleAdressePostale';
    this.titreTelephone = this.estTelephoneModifie()
      ? 'caad.modifier-fiserv.validation.nouveauNumeroTelephone'
      : 'caad.modifier-fiserv.validation.numeroTelephone';
    this.titreAdresseCourriel = this.estCourrielModifie()
      ? 'caad.modifier-fiserv.validation.nouvelleAdresseCourriel'
      : 'caad.modifier-fiserv.validation.adresseCourriel';
    this.gestionTitreService.addTitreOnglet(
      this.particuliersCreditPlusQueUn
        ? 'caad.titreOnglet.validationFiserv.titreMulticarte'
        : 'caad.titreOnglet.validationFiserv.titre'
    );
  }

  private estTelephoneModifie(): boolean {
    return (
      this.formGroupLocal.controls.telephone.value !==
      this.reponseCoordonneesCreditService.getTelephone().numeroTelephone
    );
  }

  private estCourrielModifie(): boolean {
    return this.formGroupLocal.controls.courriel.value !== this.reponseCoordonneesCreditService.getAdresseCourriel();
  }

  private getAdresseSaisie() {
    return {
      texteAdresseLigne1: this.formGroupLocal.controls.rue.value,
      texteAdresseLigne2: this.formGroupLocal.controls.appartement.value,
      nomMunicipalite: this.formGroupLocal.controls.ville.value,
      codePostal: this.formGroupLocal.controls.codePostal.value,
      codeSubdivisionPays: this.formGroupLocal.controls.province.value,
    } as AdressePhysiqueCredit;
  }
}
